module.exports = "/_next/static/images/runcycle-6c0f50bda7de817798e7cecd39543acf.gif";